import React, { useContext, useEffect, useState, useCallback } from 'react';
import RMHeader from "../../PageComponentData/wallet/RegularMonthDue/RMHeader";
import { canPayBillForCurrentMonth, getDueMonth } from "../../utils/helperFunctions";
import { CreditPurchasesPaymentSuccess, getMonthlyDue, PayMonthlyDue } from "../../apis";
import { CalcTransactionres } from "./Wallethelperfunction";
import { AppContext } from "../../appContext";
import { HighlightRow, LightRow } from './WalletMiniComponent';
import { EditProfileLoader, Loader } from '../common/loader';
import SimpleButton from '../common/buttons/SimpleButton/SimpleButton';
import ConfirmPopup from '../confirmPopup/ConfirmPopup';
import toast from 'react-hot-toast';
import useRazorpay from 'react-razorpay';
import LogoImage from '../../Assets/odds_logo_blue.png';
import NoDue from '../../Assets/img/wallet/NoDue.png';

export default function RegularMonthDueV1({ closeFunction }) {
    const { loggedInUser } = useContext(AppContext);
    const [loading, setloading] = useState(false);
    const [loader, setLoader] = useState(true);
    const [monthlyDueData, setMonthlyDueData] = useState(null);
    const [paymentHistory, setPaymentHistory] = useState(null);
    const [conformPopUp, setConformPopUp] = useState(false);
    const toGetMonthlyDue = async (payload) => {
        try {
            const res = await getMonthlyDue(payload);
            if (res.status === 200) {
                setMonthlyDueData(res?.data?.data);
                if (res?.data?.data?.TransactionRecord.length > 0) {
                    const result = await CalcTransactionres(res);
                    console.log("result", result)
                    setPaymentHistory(result);
                }
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoader(false);
        }
    };
    const toGetOrderId = async () => {
        setloading(true);
        const payload = {
            hospitalId: loggedInUser?.data?.hospitalProfile?._id,
            LedgerId: monthlyDueData?.MonthlyLedger,
        };
        try {
            const res = await PayMonthlyDue(payload);
            if (res.status === 200) {
                const dueAmt = res?.data?.order?.amount_due / 100;
                if (monthlyDueData?.TotalAmount === dueAmt) {
                    handlePayment(res?.data?.order?.id);
                }
                setloading(false);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.message || 'Something went wrong');
        } finally {
            setloading(false);
        }
    };
    function handelConfirmPopUp() {
        setConformPopUp(!conformPopUp);
    }
    const [Razorpay] = useRazorpay();
    const handlePayment = useCallback(
        (order) => {
            const order_id = order;
            if (!order_id) {
                console.error('Order ID is required for payment.');
                return;
            }
            const amountInPaise = order.amount * 100; // Convert amount to paise (smallest currency unit)
            const options = {
                key: process.env.REACT_APP_RAZARPAY_ID, // Your Razorpay key
                amount: amountInPaise.toString(), // Amount in paise
                currency: 'INR',
                name: 'MODO',
                image: LogoImage,
                order_id: order_id,
                handler: (response) => {
                    handelConfirmPopUp();
                    const payload = {
                        hospitalId: order.hospitalid,
                        razarpayOrderId: order_id,
                    };
                    paymentSuccess(payload);
                },
                prefill: {
                    name: order.name,
                    contact: order.phoneno,
                },
                theme: {
                    color: '#1648CE',
                },
                modal: {
                    ondismiss: () => {
                        handelConfirmPopUp();
                        console.log('Payment Failed or Closed');
                        toast.error('Payment Cancelled');
                        closeFunction();
                    },
                },
            };

            const rzpay = new Razorpay(options);
            rzpay.open();
        },
        [Razorpay]
    );
    const paymentSuccess = async (payload) => {
        try {
            const res = await CreditPurchasesPaymentSuccess(payload);
            if (res.status === 200) {
                // closeFunction();
                window.location.reload();
                toast.success(res.data.message || 'Credits purchased successfully');
            }
        } catch (error) {
            console.log(error);
            closeFunction();
        } finally {
        }
    };
    useEffect(() => {
        const dateObj = new Date();
        const month = dateObj.getMonth() + 1;
        const year = dateObj.getFullYear();
        const payload = {
            hospitalId: loggedInUser?.data?.hospitalProfile?._id,
            month: month <= 9 ? '0' + month : month,
            year: year,
        };
        toGetMonthlyDue(payload);
        canPayBillForCurrentMonth();
    }, [loggedInUser]);
    return (
        <div className="p-4 lg:p-0 lg:w-[400px]">
            {loader ? (
                <div className="min-h-44 flex justify-center items-center">
                    <Loader />
                </div>
            ) : (
                <>
                    {
                        (monthlyDueData == undefined && !loader) ?
                            <>
                                <RMHeader headertxt={'Amount Due'} closeFunction={closeFunction} />

                                <div className="flex justify-center items-center flex ml-auto mr-auto flex-col gap-1 mb-3">
                                    <img src={NoDue} className='p-2 h-[400px] w-[400px]' />
                                    <div className="text-base font-medium lg:text-lg lg:font-medium text-center !mb-2">
                                        You have no due for this month
                                    </div>

                                </div>
                            </>
                            :
                            <>
                                <RMHeader headertxt={'Amount Due'} closeFunction={closeFunction} />
                                {canPayBillForCurrentMonth() ? (
                                    <p className="subHeadingText mt-4">
                                        {getDueMonth(monthlyDueData?.DueMonth)} ₹
                                        {monthlyDueData?.TotalAmount}
                                    </p>
                                ) : (
                                    <p className="mt-4 baseText text-red-500">
                                        *Payment is not allowed until the end of the month.
                                    </p>
                                )}
                                <section className="py-3 space-y-3">
                                    <HighlightRow title={'Total Consultation'} data={monthlyDueData?.TransactionRecord?.length} />
                                    <LightRow title={'In-Person'} data={paymentHistory?.inPerson?.total} loopdata={paymentHistory} type={'inPerson'} />
                                    <LightRow title={'Virtual'} data={paymentHistory?.virtual?.total} loopdata={paymentHistory} type={'virtual'} />
                                    <HighlightRow title={'To Pay'} data={`₹ ${monthlyDueData?.TotalAmount}`} />

                                </section>
                                {!loader && (
                                    <div className="mt-5 mb-2">
                                        {canPayBillForCurrentMonth() ? (
                                            <SimpleButton
                                                title={`Pay ₹ ${monthlyDueData?.TotalAmount}`}
                                                buttonType={'primary'}
                                                customClass={'w-full rounded-2xl '}
                                                onClickEvent={handelConfirmPopUp}
                                            />
                                        ) : (
                                            <SimpleButton
                                                title={`Pay ₹ ${monthlyDueData?.TotalAmount}`}
                                                customClass={'w-full rounded-2xl !text-gray-700 !bg-gray-300'}
                                            />
                                        )}
                                    </div>
                                )}
                            </>
                    }

                </>
            )}
            {conformPopUp && (
                <ConfirmPopup
                    message={<p className="baseText">Are you sure you want to make this payment?</p>}
                    popupStatus={conformPopUp}
                    handelConfirmPopUp={handelConfirmPopUp}
                    onclickFunction={toGetOrderId}
                    confirmtext={loading ? <EditProfileLoader /> : 'Yes'}
                    canceltext={'No'}
                />
            )}
        </div>

    )
}